var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.19995C6.579 2.19995 2 6.77895 2 12.2C2 17.621 6.579 22.2 12 22.2C17.421 22.2 22 17.621 22 12.2C22 6.77895 17.421 2.19995 12 2.19995ZM12 7.19995C13.727 7.19995 15 8.47195 15 10.2C15 11.928 13.727 13.2 12 13.2C10.274 13.2 9 11.928 9 10.2C9 8.47195 10.274 7.19995 12 7.19995ZM6.894 16.972C7.791 15.652 9.287 14.772 11 14.772H13C14.714 14.772 16.209 15.652 17.106 16.972C15.828 18.34 14.015 19.2 12 19.2C9.985 19.2 8.172 18.34 6.894 16.972Z",
    fill: "#E9F4FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c589c7c1158998fa2bcc44c7cc83288b.svg";
export { ForwardRef as ReactComponent };